import React from 'react';
import { useThemeAuthUi } from '@olo-web/utils/google/firebase';
import { Box } from '@chakra-ui/react';
import 'firebaseui/dist/firebaseui.css';

export const FirebaseAuth = () => {
  useThemeAuthUi('#theme-auth-form');
  return <Box w="100%" id="theme-auth-form" />;
};
